"use strict";
// セレクトボックスの要素を取得
const articleSelect = document.querySelectorAll('select.article-select');
if (articleSelect) {
    // セレクトボックスの変更イベントを監視
    articleSelect.forEach(function (select) {
        select.addEventListener('change', function () {
            // 選択された値（URL）を取得
            const selectedUrl = this.value;
            // 値が空でない場合、そのURLに遷移
            if (selectedUrl && selectedUrl !== '') {
                window.location.href = selectedUrl;
            }
        });
    });
}
